"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostMetaContainer = void 0;

var _preact = require("preact");

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _common = require("@insided/shared/utils/common");

var PostMetaContainer = function PostMetaContainer(props) {
  var timestamp = props.timestamp,
      author = props.author,
      children = props.children;

  var relativeTime = _common.common.relativeDate(timestamp);

  return (0, _preact.h)("div", {
    className: "post-meta__container",
    role: "contentinfo"
  }, (0, _preact.h)("div", {
    className: "post-meta__container--left"
  }, (0, _preact.h)(_UserAvatar.default, {
    user: author,
    extraClass: "avatar avatar--XS",
    avatarBaseSize: "40x40",
    width: 21,
    height: 21
  }), (0, _preact.h)("time", {
    className: "thread-meta-item__date",
    dateTime: String(timestamp)
  }, relativeTime)), children && (0, _preact.h)("div", {
    className: "post-meta__container--right"
  }, children));
};

exports.PostMetaContainer = PostMetaContainer;